import { createAction, createReducer } from '@reduxjs/toolkit';
import frc from 'front-end-common';
import ConfigService from '../Services/ConfigService';

const { addDefaultHandlers, getDefaultState } = frc.utils.reducerTools;

export const fetchConfigs = createAction('config/get', () => ({
  payload: ConfigService.getList(),
}));

export const updateConfig = createAction('config/update', (data) => ({
  payload: ConfigService.updateConfig(data),
}));

const initState = {
  data: getDefaultState(),
  update: getDefaultState(),
};

export default createReducer(initState, (builder) => {
  addDefaultHandlers(builder, fetchConfigs, 'data');
  addDefaultHandlers(builder, updateConfig, 'update');
});
